import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';

const Tooltip = observer(() => {
    const { mainStore } = useStores();
    const [rect, setRect] = useState(null);

    useEffect(() => {
        if (!mainStore.isShowTooltip) {
            setRect(null);
            return;
        }

        let target;

        if (!mainStore.startPoi && mainStore.destinationPoi) {
            target = document.getElementById('start-field');
        }

        if (
            mainStore.startPoi &&
            mainStore.destinationPoi &&
            mainStore.startPoi?._id === mainStore.destinationPoi?._id
        ) {
            target = document.getElementById('both-field');
        }

        if (!target) return;

        const update = () => {
            const r = target.getBoundingClientRect();
            setRect({
                top: r.top,
                left: r.left,
                width: r.width,
                height: r.height,
            });
        };

        update();
        window.addEventListener('resize', update);
        window.addEventListener('scroll', update, true);

        return () => {
            window.removeEventListener('resize', update);
            window.removeEventListener('scroll', update, true);
        };
    }, [mainStore.isShowTooltip]);

    if (!rect) return null;

    const padding = 10;

    return (
        <div
            className="fixed z-[999] w-screen h-[100dvh]"
            style={{ pointerEvents: 'auto' }}
            onClick={(e) => e.stopPropagation()}
        >
            <svg
                className="fixed inset-0 z-[9999] w-full"
                width="100%"
                height="100%"
                style={{ pointerEvents: 'none' }}
            >
                <defs>
                    <mask id="tooltip-mask">
                        <rect width="100%" height="100%" fill="white" />

                        <rect
                            x={rect.left - padding}
                            y={rect.top - padding}
                            width={rect.width + padding * 2}
                            height={rect.height + padding * 2}
                            rx={padding}
                            ry={padding}
                            fill="black"
                        />
                    </mask>
                </defs>

                <rect
                    className="z-[99999]"
                    width="100%"
                    height="100%"
                    fill="rgba(0,0,0,0.4)"
                    mask="url(#tooltip-mask)"
                    style={{
                        backdropFilter: 'blur(12px)',
                        WebkitBackdropFilter: 'blur(12px)',
                    }}
                    onClick={() => {
                        mainStore.setIsShowTooltip(false);
                    }}
                />
            </svg>

            <div
                className="fixed z-[9999] left-0 bg-white rounded-[6px] px-4 py-3 w-fit"
                style={{
                    top: rect.top + rect.height + 14,
                    left: rect.left - 10,
                    boxShadow: '0 10px 40px rgba(0,0,0,0.25)',
                }}
            >
                <p className="text-sm font-medium text-[#1C1A3F] bg-2">
                    {mainStore.startPoi &&
                    mainStore.destinationPoi &&
                    mainStore.startPoi?._id === mainStore.destinationPoi?._id
                        ? 'Start and destination can’t be the same'
                        : 'Choose your start location'}
                </p>
                <p className="text-xs text-[#5C5C5C] mt-1">
                    {mainStore.startPoi &&
                    mainStore.destinationPoi &&
                    mainStore.startPoi?._id === mainStore.destinationPoi?._id
                        ? ' Tap here to select a different location.'
                        : 'Tap here to choose your starting point.'}
                </p>

                <div className="flex justify-end mt-3">
                    <button
                        className="text-xs font-medium text-[#FF6200]"
                        onClick={() => {
                            mainStore.setIsShowTooltip(false);
                        }}
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
});

export default Tooltip;
